/**
 * @copyright WaterStreet. All rights reserved.
 */

/**
 * A class containing constants for Excel exports.
 *
 * @export
 * @class ExcelConstants
 */
export class ExcelConstants
{
	/**
	 * Gets the properties for an Excel worksheet.
	 */
	public static readonly worksheetProperties: {
		range: string;
	} = {
			range: '!ref'
		};

	/**
	 * Gets the cell types for Excel cells.
	 */
	public static readonly cellTypes: {
		number: string;
	} = {
			number: 'n'
		};

	/**
	 * Gets the format types for Excel cells.
	 */
	public static readonly formatTypes: {
		shortDate: string;
		longDate: string;
		number: string;
	} = {
			shortDate: 'mm/dd/yyyy',
			longDate: 'mm/dd/yyyy h:mm a',
			number: '#,##0'
		};
}